import { render, staticRenderFns } from "./ApiTest.vue?vue&type=template&id=6f16b32b&scoped=true&"
import script from "./ApiTest.vue?vue&type=script&lang=js&"
export * from "./ApiTest.vue?vue&type=script&lang=js&"
import style0 from "./ApiTest.vue?vue&type=style&index=0&id=6f16b32b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f16b32b",
  null
  
)

export default component.exports